export const sxConfig = {
  page: {
    px: {
      xs: 1.5,
      md: 3,
    },
    pt: 2.5,
  },

  cardGridItem: {
    width: {
      xs: '50%',
      md: 350,
    },
    flexBasis: {
      xs: '50%',
      md: 350,
    },
    maxWidth: {
      xs: '50%',
      md: 350,
    },
  },

  card: {
    width: '100%',
    height: {
      xs: 200,
      md: 265,
    },
    p: 1,
    boxSizing: 'border-box',
    borderRadius: 4,
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    gap: {
      xs: 0,
      md: 1,
    },
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    transition: 'transform 300ms ease-in-out, background-color 300ms ease-in-out',
  },

  activityTitle: {
    width: '100%',
    fontSize: {
      xs: '1.25rem',
      md: '1.5rem',
    },
    fontWeight: 700,
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    order: {
      xs: 2,
      md: 1,
    },
  },

  activityIconButton: {
    m: 0,
    p: 0,
    color: 'inherit',
    pointerEvents: 'none',
    mb: {
      xs: 1,
      md: 0,
    },
    order: {
      xs: 1,
      md: 3,
    },
  },

  openReportTimerText: {
    fontVariantNumeric: 'tabular-nums',
    fontWeight: 700,
    fontSize: {
      xs: '1.25rem',
      md: '1.5rem',
    },
  },

  openReportTimer: {
    order: 3,
  },

  cardReasonContainer: {
    order: 3,
    width: '100%',
  },

  cardReasonBoxText: {
    fontWeight: 700,
    fontSize: {
      xs: '1.25rem',
      md: '1.5rem',
    },
    color: 'rgba(239, 68, 68, 1)',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },

  reasonDialog: {
    '& .MuiDialog-container': {
      '& .MuiPaper-root': {
        width: '100%',
        maxWidth: '1300px',
        mx: 1,
      },
    },
    '& .MuiDialogContent-root': {
      px: 0.5,
    },
  },

  reasonDialogBackButtonWrapper: {
    pb: 2,
  },

  reasonDialogBackButton: {
    mt: 2,
    px: 1.5,
    py: 1,
    borderRadius: 1,
    bgcolor: '#86a8c5',
    color: 'white',
  },

  reasonDialogBackIcon: {
    fontSize: {
      xs: '1.5rem',
      sm: '2rem',
    },
  },

  reasonDialogBackText: {
    fontSize: {
      xs: '1.125rem',
      sm: '1.5rem',
    },
    fontWeight: 500,
  },

  reasonGridItem: {
    p: {
      xs: 0.5,
      sm: 1,
    },
  },

  reasonCard: {
    width: {
      xs: '100%',
      sm: 220,
    },
    height: {
      xs: 120,
      sm: 200,
    },
    alignItems: 'center',
    justifyContent: 'center',
    px: 1,
    borderRadius: 2,
    bgcolor: '#6f9ad833',
    color: '#014AB1',
    border: '2px solid #014AB1',
    textAlign: 'center',
    cursor: 'pointer',
    userSelect: 'none',
    transition: 'background-color 0.2s ease',

    '&:hover': {
      bgcolor: '#6f9ad880',
    },
  },

  reasonCardText: {
    fontSize: {
      xs: '1.4rem',
      sm: '1.8rem',
    },
    fontWeight: 500,
  },
};
